export default __webpack_public_path__ + "static/media/Cartilha_LGPD_2021.de4018da.pdf";